import React from 'react';
import { Modal, Table, Tag, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { BatchResponse, BatchResultItem } from '../../../services/batchApprovalApi';

const { Text } = Typography;

// ============================================================
// Props
// ============================================================

interface BatchResultModalProps {
  visible: boolean;
  data: BatchResponse | null;
  onClose: () => void;
  title?: string;
}

// ============================================================
// Component
// ============================================================

const BatchResultModal: React.FC<BatchResultModalProps> = ({
  visible,
  data,
  onClose,
  title = '批次操作結果',
}) => {
  const columns: ColumnsType<BatchResultItem> = [
    {
      title: '模組',
      dataIndex: 'modId',
      key: 'modId',
      width: 100,
    },
    {
      title: '單據號碼',
      dataIndex: 'recordNo',
      key: 'recordNo',
      width: 140,
      render: (text: string) => <Text code>{text}</Text>,
    },
    {
      title: '結果',
      dataIndex: 'success',
      key: 'success',
      width: 80,
      align: 'center',
      render: (ok: boolean) =>
        ok ? <Tag color="success">成功</Tag> : <Tag color="error">失敗</Tag>,
    },
    {
      title: '訊息',
      dataIndex: 'message',
      key: 'message',
      ellipsis: true,
    },
  ];

  const results = data?.results || [];

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      onOk={onClose}
      width={640}
      cancelButtonProps={{ style: { display: 'none' } }}
      okText="關閉"
    >
      {data && (
        <div style={{ marginBottom: 12 }}>
          <Text>
            成功 <Text strong style={{ color: '#389e0d' }}>{data.success}</Text> 筆
            {data.failed > 0 && (
              <>
                ，失敗 <Text strong style={{ color: '#cf1322' }}>{data.failed}</Text> 筆
              </>
            )}
          </Text>
        </div>
      )}
      <Table<BatchResultItem>
        rowKey={(r) => `${r.modId}::${r.recordNo}`}
        columns={columns}
        dataSource={results}
        size="small"
        pagination={false}
        scroll={{ y: 300 }}
        locale={{ emptyText: '無結果' }}
      />
    </Modal>
  );
};

export default BatchResultModal;
